import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ChunkEvaluationAction = createAsyncThunk("chunkEvaluation",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.chunkEvaluation, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

export const ChunkEvaluationSlice = createSlice({
    name: "chunkEvaluation",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        chunkEvaluationReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [ChunkEvaluationAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [ChunkEvaluationAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;
        },
        [ChunkEvaluationAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        },
    }
})


export const { chunkEvaluationReset } = ChunkEvaluationSlice.actions